import { render, staticRenderFns } from "./StudipTreeViewWidget.vue?vue&type=template&id=8efc964c&"
import script from "./StudipTreeViewWidget.vue?vue&type=script&lang=js&"
export * from "./StudipTreeViewWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports